const DEFAULT_PALETTE = {
  primary: '#2597FE',
  secondary: '#313b5d',
  accent: '#9C27b0',
  info: '#00CAE3',
  softGreen: '#32bb8b',
  softRed: '#F04344',
  softBackgroundGrey: '#F7F8FB',
  darkBackgroundGrey: '#eeeeee',
  softTextGrey: '#999',
  darkTextGrey: '#636363',
  softAdvise: '#fffcf7',
  accentYellow: '#FFCD29',

  softWarning: '#f9f6ea',
  softError: '#f9eaea',
  softInfo: '#eaf3fc',

  softPrimary: '#eaf3fc',
  softBackgroundGreen: '#e6f4ea',
  superSoftBackgroundGreen: '#f4f9f6',
  darkGreen: '#137333',
  softBackgroundRed: '#fce8e6',
  superSoftBackgroundRed: '#f9f4f4',
  darkRed: '#a50e0e',

  chartsBarBlue: '#B8DBFF',
  chartsBarGreen: '#BEEECC',
  chartsBarRed: '#FFBEB8',

  upgradeGreen: '#7DE9C5',
}

const DARK_DEFAULT_PALETTE = {
  ...DEFAULT_PALETTE,

  // only for dark
  dark_backgroundTotalBlack: '#121212', // casi negro, por defecto el negro de fondo de vuetify dark
  dark_backgroundBlack: '#1E1E1E',
  dark_backgroundLighterBlack: '#292929',
  dark_backgroundGrey: '#5B5B5B',
  dark_backgroundDarkBlue: '#323940',
  dark_backgroundSoftBlue: '#3b444c',
  dark_Textgrey: '#A5A5A5',

  // overwrite colors for dark:
  softBackgroundGrey: '#323940',
  secondary: '#A5A5A5',
  accentYellow: '#fcd358',
  softWarning: '#323940',
  softInfo: '#323940',
  softBackgroundRed: '#5d1f1a',
  superSoftBackgroundRed: '#2b2221',
  softBackgroundGreen: '#174b35',

  chartsBarBlue: '#579DFF',
  chartsBarGreen: '#206D4D',
  chartsBarRed: '#AD2E24',
}

const SEQUENCE_PALETTE = {
  a: '#2698FF',
  b: '#26E5FF',
  c: '#FFB443',
  d: '#FF7B43',
  e: '#FF4343',
  f: '#FF4387',
  g: '#FF44CB',
  h: '#D7DBE0',
  i: '#F1F8FF',
  j: '#7DE9C5',
  k: '#1AE9AC',
  l: '#2BCE86',
  m: '#80CD35',
  n: '#FFD545',
  o: '#FFC875',
  p: '#FF9E75',
  q: '#FF7575',
  r: '#FF75A7',
  s: '#7DC1FF',
  t: '#7DEFFF',
}

const DONUT_PALETTE = SEQUENCE_PALETTE

const ORDERS_TYPE_PALETTE = {
  buy: DEFAULT_PALETTE.primary,
  sell: DEFAULT_PALETTE.softRed,
  switch: DEFAULT_PALETTE.softTextGrey,
  switchBuy: DEFAULT_PALETTE.primary,
  spinOff: 'rgb(122, 17, 178)',
  spinOffBuy: 'rgb(122, 17, 178)',
  sharePremium: SEQUENCE_PALETTE.c,
  capitalIncrease: SEQUENCE_PALETTE.f,
  scrip: SEQUENCE_PALETTE.d,
  split: '#1AE9AB',
  brokerTransfer: DEFAULT_PALETTE.darkTextGrey,
  bonus: '#19B7E9',
  stakeReward: DEFAULT_PALETTE.softGreen,
  drip: DEFAULT_PALETTE.secondary,
  deposit: DEFAULT_PALETTE.softGreen,
  withdrawal: DEFAULT_PALETTE.softRed,
  commission: DEFAULT_PALETTE.softRed,
  paidInterest: 'rgba(0, 0, 0, 0.54)',
  interest: DEFAULT_PALETTE.softGreen,
  interestRetention: DEFAULT_PALETTE.softRed,
  optionBuy: DEFAULT_PALETTE.primary,
  optionSell: DEFAULT_PALETTE.softRed,
}

const DIVIDENDS_TYPE_PALETTE = {
  stockDividend: DEFAULT_PALETTE.primary,
  coupon: DEFAULT_PALETTE.softGreen,
}

module.exports = {
  DEFAULT_PALETTE,
  DONUT_PALETTE,
  ORDERS_TYPE_PALETTE,
  DIVIDENDS_TYPE_PALETTE,

  DARK_DEFAULT_PALETTE,
}
